import API from 'types/api';
import APP from 'types/app';

const initialState = {
  isLoading: false,
  isLoaded: false,
  isError: false,
  videoList: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case API.GET_VIDEO_COLLECTION_FETCH:
      return { ...state, isLoading: true };
    case API.GET_VIDEO_COLLECTION_SUCCESS:
      return {
        ...state,
        videoList: payload,
        isLoading: false,
        isError: false,
        isLoaded: true,
      };
    case API.GET_VIDEO_COLLECTION_ERROR:
      return {
        ...state,
        isLoaded: false,
        isLoading: false,
        isError: true,
      };
    case APP.RESET_SUBSCRIPTIONS_VIDEO_COLLECTIONS:
      return {
        ...state,
        isLoaded: false,
        isLoading: false,
        isError: false,
      };
    default:
      return state;
  }
};
